import { fetchApi } from "./api";
import { buildNewsletterHtml, type NewsletterArticle } from "./newsletter.html";

function getOrigin(): string {
  return (import.meta.env.VITE_SITE_URL as string | undefined) ?? window.location.origin;
}

// Public: fetch the article for a newsletter preview and build the email HTML
// client-side (buildNewsletterHtml is pure).
export const getNewsletterArticle = async (opts: {
  data: { slug: string };
}): Promise<{ article: NewsletterArticle; html: string } | null> => {
  const article = await fetchApi<NewsletterArticle | null>(
    "content",
    "getNewsletterArticle",
    { slug: opts.data.slug },
    { auth: false },
  );
  if (!article) return null;
  return { article, html: buildNewsletterHtml(article, getOrigin()) };
};

// Admin-only: send a sample newsletter email.
export const sendSampleNewsletter = (opts: { data: { slug: string; email: string } }) =>
  fetchApi<{ ok: true; provider: string }>("content", "sendSampleNewsletter", opts.data);
